import { Component, OnInit, Inject, Optional } from '@angular/core';
import { Redirection, ExpressResponse, ExpressRequest, Cookies } from 'common';
import { ActivatedRoute } from '@angular/router';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import { UserService } from 'user';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss']
})
export class SsoComponent implements OnInit {

  constructor(
    private redirection : Redirection,
    private route : ActivatedRoute,
    private cookies : Cookies,
    private userService : UserService,
    @Optional() @Inject(RESPONSE)
    private request : ExpressRequest,
    @Optional() @Inject(RESPONSE)
    private response : ExpressResponse
  ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe(paramMap => {
      let returnURL = paramMap.get('return');

      if (!returnURL.startsWith('https://tytnetwork.com')) {

        if (this.response)
          this.response.status(401);
        return;
      } else {
        let delimiter = '?';

        if (returnURL.includes('?'))
          delimiter = '&';

        let cookie = this.cookies.get<any>('tytauth');
        this.redirection.go(`${returnURL}${delimiter}token=${encodeURIComponent(cookie ? cookie.token : '')}`);
      }
    });
  }

}
